export default {
    appBaseUrl: import.meta.env.VITE_APP_BASE_URL,
    apiBaseUrl: `${import.meta.env.VITE_APP_BASE_URL}/api`,
    localStorageVersion: 'v0',
}